// Module
var code = "<tr data-nid=\"<%- nid %>\"> <td><%- nid %></td> <td><%- name %></td> <td><input class=postbackInput type=text value=\"<%- postBack %>\"></td> <td> <button type=button class=\"unfilterLink btn <%- filterClass %>\"><%- filterText %></button> </td> </tr> ";
// Exports
module.exports = code;